var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page', ("page--step" + (_vm.$root.step))]},[_c('header',{staticClass:"page__header"},[_c('Header')],1),_c('section',{staticClass:"page__wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }